export default __webpack_public_path__ + "static/media/placeholder1.084c2fca.jpg";